import Dialog from "../1. Core/Controls/Dialog/Dialog";
import {VideoSource} from "./types";
import {ServerAPI} from "../1. Core/ServerAPI";
import TextField from "../1. Core/Controls/TextField/TextField";
import Select from "../1. Core/Controls/Select/Select";
import ImageTextField from "../1. Core/Controls/TextField/ImageTextField";


export default class EditVideoSourceDialog extends Dialog {


    private _VideoSource: VideoSource;
    private _name: TextField;
    private _channelId: TextField;
    private _lang: Select;
    private _provider: Select;
    private _logoUrl: ImageTextField;
    private _accessToken: TextField;


    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._VideoSource = {lang: 'en', provider: 'youtube'} as VideoSource;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'VideoSource';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
    }

    _render() {
        super._render();

        this._name = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name'
        });

        this._provider = new Select({
            FloatingLabel: 'Provider',
            ParentNode: this._contentNode,
            Value: 'youtube',
            Items: [
                {Content: 'YouTube', Value: 'youtube'},
                {Content: 'VK', Value: 'vk'},
            ]
        });

        this._channelId = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Channel / VK (YouTube id, vk.com / vk.ru / vkvideo.ru/@…, screen name or id)'
        });

        this._lang = new Select({
            FloatingLabel: 'Lang',
            ParentNode: this._contentNode,
            Value: 'en',
            Items: [
                {Content: 'ru', Value: 'ru'},
                {Content: 'en', Value: 'en'},
                {Content: 'es', Value: 'es'},
                {Content: 'pt', Value: 'pt'},
            ]
        });

        this._logoUrl = new ImageTextField({
            ParentNode: this._contentNode,
            TextFieldSettings: {FloatingLabel: 'LogoUrl'}
        });

        this._accessToken = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'VK access_token (optional, for provider=vk)'
        });

        this.refresh()
    }


    async refresh() {
        this._name.setValue(this._VideoSource.name)
        this._channelId.setValue(this._VideoSource.channelId)
        const rawLang = (this._VideoSource.lang || 'en').toLowerCase()
        // старые источники с pt-br показываем как pt
        this._lang.setValue(rawLang === 'pt-br' || rawLang.startsWith('pt-') ? 'pt' : rawLang)
        this._logoUrl.setValue(this._VideoSource.logoUrl || '')
        this._accessToken.setValue(this._VideoSource.accessToken || '')

        let vkLabel = 'VK';
        try {
            const meta = await ServerAPI.get(`/video-source/meta`) as {vkTokenConfigured?: boolean};
            if (!meta?.vkTokenConfigured) {
                vkLabel = 'VK (inactive)';
            }
        } catch {
            vkLabel = 'VK (inactive)';
        }
        const provider = this._VideoSource.provider || 'youtube';
        this._provider.setItems([
            {Content: 'YouTube', Value: 'youtube'},
            {Content: vkLabel, Value: 'vk'},
        ]);
        this._provider.setValue(provider);
    }


    async _onOkButtonClick() {

        this._VideoSource.name = this._name.getValue()
        this._VideoSource.channelId = this._channelId.getValue()
        this._VideoSource.lang = this._lang.getValue()
        this._VideoSource.provider = this._provider.getValue() || 'youtube'
        this._VideoSource.logoUrl = this._logoUrl.getValue()
        this._VideoSource.accessToken = this._accessToken.getValue()

        if (this._VideoSource.id)
            await ServerAPI.post(`/video-source/${this._VideoSource.id}`, this._VideoSource)
        else
            await ServerAPI.post(`/video-source/`, this._VideoSource);


        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}
